import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';
import { View } from 'react-native';
import { styleMobile as style } from './HeaderV3.style';
import { MainLogoPressable } from '@photosi/rn-components/main-logo-pressable/MainLogoPressable';
import { ChatButton } from 'src/_shared/chat/ChatButton';
import { SaveButton } from '../components/save-button/SaveButton';
import { HelpButton } from '../../help-button/HelpButton';
import { PhotoSlotButton } from 'src/editor-v3/components/photo-slot-button/PhotoSlotButton';
import { THeaderProps } from '../header/Header.types';
import { HEADER_V3 } from '../header/header.constants';
import { MOBILE_MAIN_HEADER_V3_HEIGHT } from './HeaderV3.constants';
import { headerEditorTestID } from 'src/helpers/testIDs.helper';
import { TestIDs } from 'src/constants/testIDs.constants';
import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';

export const HeaderMobileV3 = observer(({ children }: THeaderProps) => {
  const { project } = useStore();

  return (
    <View
      style={[style.headerContainer, { height: children ? HEADER_V3.height.mobile : MOBILE_MAIN_HEADER_V3_HEIGHT }]}
      accessibilityRole="toolbar"
    >
      <View style={style.mainHeader}>
        <View style={style.leftElements}>
          <MainLogoPressable
            testID={TestIDs.PHOTOSI_LOGO}
            focusId={TestIDs.PHOTOSI_LOGO}
            focusOrder={0}
            focusGroup={FocusGroups.HEADER}
          />
        </View>
        <View style={style.rightElements}>
          {!project.isProjectAddedToCart && (
            <PhotoSlotButton
              focusId={headerEditorTestID(TestIDs.PHOTO_DRAWER, 'button')}
              focusOrder={1}
              focusGroup={FocusGroups.HEADER}
            />
          )}
          <SaveButton focusId={headerEditorTestID(TestIDs.SAVE)} focusOrder={2} focusGroup={FocusGroups.HEADER} />
          <HelpButton
            focusGroup={FocusGroups.HEADER}
            focusId={headerEditorTestID(TestIDs.HELP_BUTTON)}
            focusOrder={3}
          />
          <ChatButton newGraphic focusGroup={FocusGroups.HEADER} focusOrder={4} />
        </View>
      </View>

      {children}
    </View>
  );
});
